import { c as _c } from "react/compiler-runtime";
import { Link } from "@flat-ui";
import { REQUEST_A_QUOTE_URL } from "@src/constants/subscription-constants";
import { OPEN_OTHERS_TARGET_ATTRIBUTE } from "@utils/project-utils";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useCallback } from "react";
/** Subtitle of the subscription settings with contact info of the sales team */
export function SubscriptionInfoSubtitle(t0) {
  const $ = _c(7);
  const {
    name
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== trackEvent) {
    t1 = event => {
      event.preventDefault();
      event.stopPropagation();
      trackEvent({
        name: WorkspaceEvents.requestAQuote
      });
      window.open(REQUEST_A_QUOTE_URL, OPEN_OTHERS_TARGET_ATTRIBUTE);
    };
    $[0] = trackEvent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onRequestAQuote = t1;
  const text = name ? `You are subscribed to the ${name} plan. ` : "You are not subscribed to any plan.";
  let t2;
  if ($[2] !== onRequestAQuote) {
    t2 = <Link href={REQUEST_A_QUOTE_URL} onClick={onRequestAQuote}>Upgrade plan or request a quote</Link>;
    $[2] = onRequestAQuote;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2 || $[5] !== text) {
    t3 = <>{text}{t2}</>;
    $[4] = t2;
    $[5] = text;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}